import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { PermissionsClient } from "@/features/permissions/PermissionsClient";
import { getPermissionsMatrix, permissionsKeys } from "@/features/permissions/permissions.api";

export const Route = createFileRoute("/_shell/permissions")({
  beforeLoad: ({ context }) => {
    if (!context.session.roles.includes("admin")) {
      throw redirect({ to: "/dashboard" });
    }
  },
  component: PermissionsScreen,
});

function PermissionsScreen() {
  const matrixQuery = useQuery({
    queryKey: permissionsKeys.matrix,
    queryFn: getPermissionsMatrix,
  });

  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Permissions">
      <PermissionsClient
        matrix={matrixQuery.data}
        isFetching={matrixQuery.isFetching}
        isLoading={matrixQuery.isLoading}
      />
    </div>
  );
}
